import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AbstractView } from 'src/app/core/abstract_view';

@Component({
  selector: 'app-client-menu',
  templateUrl: './client-menu.component.html'
})
export class ClientMenuComponent extends AbstractView implements OnInit {
  public model: any[] = [];

  constructor(public messageService: MessageService, public router: Router) {
    super(messageService, router);
  }

  ngOnInit(): void {
    this.model.push({
      label: 'Administración de Clientes',
      icon: 'pi pi-user-edit',
      routerLink: ['/client/edit-client'],
    });
  }

}
